module.exports = __webpack_public_path__ + "files/a07b6c5e6b2c6e4a4da363556c1e1a9a.svg";